<template>
<div id="app">
<aside-menu @triggerMarkerPopup="openPopup" ref="menu" />
<maskMap ref="map"></maskMap>
<lightbox></lightbox>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import asideMenu from './components/asideMenu.vue'
import lightbox from './components/lightbox.vue';
import maskMap from './components/maskMap.vue';
export default {
  name: 'App',
  components: { asideMenu,lightbox, maskMap },
  methods:{
    ...mapActions(['fetchLocation','fetchPharmacies']),
    openPopup(id) {
      this.$refs.map.triggerPopup(id);
    },

  },
  mounted(){
    this.fetchLocation();
    this.fetchPharmacies();
  }
}
</script>

<style lang="scss" src="./style.scss"></style>